import styled from 'styled-components'

import Radio from 'components/Controls/Radio/Radio/StyledRadio'

const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: ${p => (p.layout === 'horizontal' ? 'row' : 'column')};

  ${Radio} {
    margin-right: 2rem;
    ${p => p.layout === 'vertical' && 'margin-bottom: 1rem;'}
  }
`

export default StyledRadioGroup
